// extracted by mini-css-extract-plugin
export default {"AcceptPartnerInvite__title":"AcceptPartnerInvite__AcceptPartnerInvite__title__KoGgU","AcceptPartnerInvite__subtitle":"AcceptPartnerInvite__AcceptPartnerInvite__subtitle__o3Bsk"};